import React from "react";
import { Helmet } from "react-helmet";
import HTMessagesBody from "../components/ht-messages/HTMessagesBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function HTMessages() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.KampalaCityGrammarSchool.com/headteacher-messages"
        />
        <meta
          name="description"
          content="A Unique Educational Community where learners enjoy a Modern and Personalized approach to Education.  "
        />
        <meta
          name="og:title"
          content="Head Teacher's Message | Kampala City Grammar Nursery, Day and Boarding Primary School"
        />
        <meta
          name="og:url"
          content="https://KampalaCityGrammarSchool.com/Head Teacher's Message"
        />
        <meta
          name="og:description"
          content="A Unique Educational Community where learners enjoy a Modern and Personalized approach to Education.  "
        />
        <meta
          name="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1689752469/g7_nskbfi.jpg"
        />
        <meta
          name="twitter:title"
          content="Head Teacher's Message | Kampala City Grammar Nursery, Day and Boarding Primary School"
        />
        <meta
          name="twitter:text:title"
          content="Head Teacher's Message | Kampala City Grammar Nursery, Day and Boarding Primary School"
        />
        <meta
          name="twitter:description"
          content="A Unique Educational Community where learners enjoy a Modern and Personalized approach to Education.  "
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1689752469/g7_nskbfi.jpg"
        />

        <title>
          Head Teacher's Message | Kampala City Grammar Nursery, Day and
          Boarding Primary School
        </title>
      </Helmet>
      <PageHero
        classes="footerImgBg"
        titleClasses="title uppercase crimson"
        title="Head Teacher's Message"
      />
      <HTMessagesBody />
    </>
  );
}
